import DOMPurify from 'dompurify';
import { marked } from 'marked';

import { keepOnlyRichTextColorStyle } from '../../../components/rich-text/text-color';
import { stripJvisActionComment } from './jvisChatActions';

marked.setOptions({
  breaks: true,
  gfm: true,
});

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'del',
  'code',
  'pre',
  'a',
  'blockquote',
  'span',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'img',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
];
const ALLOWED_ATTR = [
  'href',
  'target',
  'rel',
  'class',
  'data-user-id',
  // 글자 색(<span style="color: …">) — sanitize 뒤 프리셋 색 하나로 좁힌다.
  'style',
  'src',
  'alt',
  'title',
  'align',
  'colspan',
  'rowspan',
];

export function renderChatMarkdown(
  body: string,
  mentionNames: Record<string, string> = {},
): string {
  let text = body;
  for (const [userId, name] of Object.entries(mentionNames)) {
    text = text.replaceAll(
      `<@${userId}>`,
      `<span class="chat-mention" data-user-id="${userId}">@${name}</span>`,
    );
  }
  const html = String(marked.parse(text, { async: false }));
  return keepOnlyRichTextColorStyle(DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR }));
}

export function extractMentionIds(body: string): string[] {
  const ids = new Set<string>();
  const re = /<@([a-z0-9]+)>/gi;
  let match: RegExpExecArray | null;
  while ((match = re.exec(body)) !== null) {
    if (match[1]) ids.add(match[1]);
  }
  return Array.from(ids);
}

function stripMarkdownSyntax(text: string): string {
  return text
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '[이미지]')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^>\s?/gm, '')
    .replace(/^\s*[-*+]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '');
}

export function formatMessagePreview(body: string | null | undefined, max = 80): string {
  if (!body) return '';
  const plain = stripMarkdownSyntax(stripJvisActionComment(body).replace(/<@[^>]+>/g, '@'))
    .replace(/\s+/g, ' ')
    .trim();
  return plain.length > max ? `${plain.slice(0, max)}…` : plain;
}

export function isChatDraftEmpty(body: string | undefined | null): boolean {
  return !hasMessageBody(body);
}

export function hasMessageBody(body: string | undefined | null): boolean {
  if (!body) return false;
  const trimmed = body.trim();
  if (!trimmed) return false;
  if (/^(\s|<br\s*\/?>)*$/i.test(trimmed)) return false;
  return true;
}
